export const UPDATE_SGZ_MARKER_REAL_TIME = 'UPDATE_SGZ_MARKER_REAL_TIME'

export function sgzMarkerRealTimeReducer (state = {}, action) {
    switch (action.type){
        case UPDATE_SGZ_MARKER_REAL_TIME:
            return action.payload
        default: return state
    }
}
